module.exports = __webpack_public_path__ + "stylesheets/wave-my-projects_b3020080af2e1bda921712fe157bc3af.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/wave/wave-my-projects.less
// module id = hQA3
// module chunks = 154